export const SET_VIDEO_STATUS = "SET_VIDEO_STATUS";
export const SET_AUDIO_STATUS = "SET_AUDIO_STATUS";
export const SET_ROOM_STATUS = "SET_ROOM_STATUS";
export const SET_CONNECTED_ROOM = "SET_CONNECTED_ROOM";
export const SET_CURRENT_QUESTION = "SET_CURRENT_QUESTION";
export const IS_EVIDENCE_COMPLETED = "IS_EVIDENCE_COMPLETED";
export const EVIDENCE_INPROGRESS_INSTANCE = "EVIDENCE_INPROGRESS_INSTANCE";
export const SET_DNSD_SID = "SET_DNSD_SID";
export const SET_CALL_ENDED = "SET_CALL_ENDED";
export const SET_QUESTION_PAYLOAD = "SET_QUESTION_PAYLOAD";
export const SET_AUDIT_SUBMITTED = "SET_AUDIT_SUBMITTED";
export const SET_MULTIPLE_CAMERA = "SET_MULTIPLE_CAMERA";
export const SET_SELECTED_CAMERA = "SET_SELECTED_CAMERA";
export const SET_SHOW_QUESTION = "SET_SHOW_QUESTION";
export const SET_MUTED_PARTICIPENT_CONTEXT = "SET_MUTED_PARTICIPENT_CONTEXT";
export const SET_MUTED_VIDEO_PARTICIPENT_CONTEXT = "SET_MUTED_VIDEO_PARTICIPENT_CONTEXT";
